const consoleRoutes = {
  account: '/account',
  analytics: '/analytics',
  apiClientsOld: '/api-clients',
  apiClients: '/clients',
  apps: '/apps',
  home: '',
  tenants: '/tenants',
  entitlements: '/entitlements',
  users: '/users',
  thirdPartyIntegrations: '/third-party-integrations',
};

export default consoleRoutes;
